module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./EmployeeUserListView.jsx"));
	}, "EmployeeUserList");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EmployeeUserList!./src/pages/bundle-org-mgmt/EmployeeUserList/EmployeeUserListView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=EmployeeUserList!./src/pages/bundle-org-mgmt/EmployeeUserList/EmployeeUserListView.jsx
// module chunks = 43